import { useState, useRef, useMemo } from 'react';
import { useOnClickOutside } from 'Shared/util/custom-hooks';
import useTranslationContext from 'Contexts/translation-context';
import useBrandContext from 'Contexts/brand-context';
import InlineSvg from 'Shared/components/inline-svg';
import Animation from 'Shared/components/animation';
import styles from './language-switch.css';


const languages = [{
  code: 'sv',
  label: 'Svenska',
}, {
  code: 'en',
  label: 'English',
}, {
  code: 'fi',
  label: 'Suomi',
}];

const getLanguageLabel = (languageCode) => {
  const selectedLanguage = languages.find((lang) => lang.code === languageCode);
  return (selectedLanguage ? selectedLanguage.label : '');
};


const LanguageSwitch = () => {
  const [showList, setShowList] = useState(false);
  const { translationData, changeLanguage } = useTranslationContext();
  const { brandData } = useBrandContext();
  const containerRef = useRef();

  const selectedLanguageLabel = useMemo(() => getLanguageLabel(translationData.languageCode), [translationData.languageCode]);
  const supportedLanguages = useMemo(() => languages.filter((l) => (brandData.supportedLanguages || []).includes(l.code)), [brandData.supportedLanguages]);

  const handleToggleList = () => setShowList(!showList);
  const handleHideList = () => (showList && setShowList(false));

  useOnClickOutside(containerRef, handleHideList);

  const handleLanguageChange = (e) => {
    changeLanguage(e.currentTarget.dataset.languagecode);
    handleHideList();
  };

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.selectContainer} onClick={handleToggleList}>
        <InlineSvg src="/globe.svg" />
        <span className={styles.languageLabel}>
          {selectedLanguageLabel}
        </span>
      </div>
      <Animation
        show={showList}
        animation="slide_down"
      >
        <div className={styles.list}>
          <ul>
            {supportedLanguages.map((language) => (
              <li key={language.code}>
                <button
                  type="button"
                  data-languagecode={language.code}
                  onClick={handleLanguageChange}
                >
                  {language.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Animation>
    </div>
  );
};

export default LanguageSwitch;
